exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-c2e726fe]:export{navy:#001d38;turquoiseBlue:#00adbc;white:#fff;black:#000;error:#b71c1c;cancel:#f75b4a;success:#7ed321}.pack-container[data-v-c2e726fe]{width:100%;height:300px}.carousel-container[data-v-c2e726fe]{width:100%;height:220px}", ""]);

// exports
